// ----------------------------------------------------------------------

export default function Tooltip(theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.grey[0],
          color: theme.palette.grey[700],
        },
        arrow: {
          color: theme.palette.grey[800],
        },
      },
    },
  };
}
